import { setSize, createAnimationobject, prepareSpliteText } from "./fryingpanAnimationUtill";

export default class fryingpanCareManager {
  constructor(param, scroll) {
    this.param = param;
    this.scroll = scroll;
  }
  init() {
    setTimeout(() => {
      this.setupAnimation()
      this.isReady = true
    }, 100)
  }

  render() {
    this._y = this.scroll.nowInc

    if (this.pKv && !this.pKv.isShown && this._y > this.pKv.topStart) {
      this.pKv.isShown = true
      this.animateKv(this.pKv)
    }

    if(this.pColumn) {
      const notShownList = this.pColumn.filter((item) => { return !item.isShown })
      notShownList.forEach((item) => {
        if (this._y > item.topStart) {
          item.isShown = true
          this.animateColumn(item.animationElms)
        }
      })
    }
  }

  setupAnimation() {
    // kv area
    this.pKv = {}
    setSize({ object: this.pKv, property: '.js-fryingpan-kv' })
    const { splitText, stTl } = prepareSpliteText(document.querySelector('.js-kv-title-en'), { opacity: 0, y: -15 })
    this.pKv.splitText = splitText
    this.pKv.stTl = stTl
    TweenMax.set('.js-kv-title', { opacity: 0 })
    TweenMax.set('.js-kv-title-jp', { opacity: 0, y: 10 })
    TweenMax.set('.js-kv-gradient', { opacity: 1 })
    TweenMax.set('.js-kv-cover', { opacity: 1 })
    TweenMax.set('.js-content-body', { opacity: 0 })
    TweenMax.set('.js-content-title', { opacity: 0, rotationX: 40, y: 10 })
    TweenMax.set('.js-content-text', { opacity: 0, y: 10 })

    // column area
    this.pColumn = []
    Array.prototype.forEach.call(
      document.querySelectorAll('.js-column'),
      (el) => {
        const obj = createAnimationobject(el, 0.8)
        obj.animationElms = {
          sub: el.querySelector('.js-column-sub'),
          title: el.querySelector('.js-column-title'),
          text: el.querySelector('.js-column-text'),
          link: el.querySelector('.js-column-link') ? el.querySelector('.js-column-link') : null,
        }

        this.pColumn.push(obj)
      }
    )
    // setting
    TweenMax.set('.js-column-sub', { opacity: 0, y: 10 })
    TweenMax.set('.js-column-title', { opacity: 0 })
    TweenMax.set('.js-column-text', { opacity: 0, y: 10 })
    TweenMax.set('.js-column-link', { opacity: 0, y: 10 })
  }

  animateKv(obj) {
    obj.stTl
      .to('.js-kv-title', 0.2, { opacity: 1 }, 0.3)
      .to('.js-kv-cover', 0.6, { opacity: 0, ease: Sine.easeIn }, 0.3)
      .to('.js-kv-gradient', 0.7, { opacity: 0, ease: Sine.easeIn }, "-=0.1")
      .to('.js-kv-title-jp', 0.5, { opacity: 1, y: 0, ease: Sine.easeOut }, "-=0.2")
      .staggerTo(obj.splitText.chars, 0.1, { opacity: 1, y: 0, ease: Back.easeOut.config(1.8) }, 0.03, "-=0.5")
      .to('.js-content-body', 0.2, { opacity: 1, ease: Sine.easeIn }, "-=0.5")
      .to('.js-content-title', 0.6, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeIn }, "-=0.3")
      .to('.js-content-text', 0.5, { opacity: 1, y: 0 }, "-=0.4")
  }

  animateColumn(elms) {
    const aclTl = new TimelineMax()
    aclTl
      .to(elms.sub, 0.4, { opacity: 1, y: 0, onComplete: () => {
        elms.sub.classList.add('is-active')
      } }, 0)
      .to(elms.title, 0.5, { opacity: 1 }, "-=0.4")
      .to(elms.text, 0.3, { opacity: 1, y: 0, onStart: () => {
        if(elms.link) TweenMax.to(elms.link, 0.3, { opacity: 1, y: 0 })
      } }, "-=0.4")
  }

  resize(_w, _h, _display) {}
}
